import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import type { SafeHtml } from "@angular/platform-browser";

export interface TipoIncidenciaAditionalInfoDialogData {
    html: SafeHtml;
    isSolicitud: boolean;
}

@Component({
    selector: "app-tipo-incidencia-aditional-info-dialog",
    templateUrl: "./tipo-incidencia-aditional-info-dialog.component.html",
    styleUrls: ["./tipo-incidencia-aditional-info-dialog.component.scss"],
    standalone: false
})
export class TipoIncidenciaAditionalInfoDialogComponent {
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: TipoIncidenciaAditionalInfoDialogData,
        private dialogRef: MatDialogRef<TipoIncidenciaAditionalInfoDialogComponent>
    ) {}

    cerrar(): void {
        this.dialogRef.close();
    }
}
